// extracted by mini-css-extract-plugin
module.exports = {"is-transparent":"pagination_is-transparent__28WQM","has-width-6":"pagination_has-width-6__LcKWv"};